module.exports = __webpack_public_path__ + "static/media/americanexpress.c49f38bd.png";